import { render, staticRenderFns } from "./InboxComposePanel.vue?vue&type=template&id=ec6dceba&scoped=true"
import script from "./InboxComposePanel.vue?vue&type=script&lang=js"
export * from "./InboxComposePanel.vue?vue&type=script&lang=js"
import style0 from "./InboxComposePanel.vue?vue&type=style&index=0&id=ec6dceba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6dceba",
  null
  
)

export default component.exports